import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "schedule-status__circle"
}
const _hoisted_2 = {
  class: "schedule-status__pict",
  style: {"background-color":"#29a3291a"}
}
const _hoisted_3 = {
  key: 0,
  class: "pict-wrap"
}
const _hoisted_4 = {
  key: 1,
  class: "schedule-status__pict",
  style: {"background-color":"#002eb81a"}
}
const _hoisted_5 = { class: "pict-wrap" }
const _hoisted_6 = {
  key: 2,
  class: "schedule-status__pict",
  style: {"background-color":"#009a9a1a"}
}
const _hoisted_7 = { class: "pict-wrap" }
const _hoisted_8 = {
  key: 3,
  style: {"background-color":"#cc00001a"},
  class: "schedule-status__pict"
}
const _hoisted_9 = { class: "pict-wrap" }
const _hoisted_10 = {
  key: 4,
  style: {"background-color":"#cc55001a"},
  class: "schedule-status__pict"
}
const _hoisted_11 = { class: "pict-wrap" }
const _hoisted_12 = {
  key: 5,
  style: {"background-color":"#cc84001a"},
  class: "schedule-status__pict"
}
const _hoisted_13 = { class: "pict-wrap" }
const _hoisted_14 = {
  key: 6,
  class: "schedule-status__pict",
  style: {"background-color":"#365d6f1a"}
}
const _hoisted_15 = { class: "pict-wrap" }
const _hoisted_16 = {
  key: 7,
  class: "schedule-status__pict",
  style: {"background-color":"#6600001a"}
}
const _hoisted_17 = { class: "pict-wrap" }
const _hoisted_18 = {
  key: 8,
  class: "schedule-status__pict",
  style: {"background-color":"#7a7a7a1a"}
}
const _hoisted_19 = { class: "pict-wrap" }
const _hoisted_20 = { key: 1 }

import {
  ref,
  computed,
  onMounted,
  watch,
  PropType,
} from "vue";
import {
  CheckBadgeIcon,
  PauseIcon,
  ClockIcon,
  CrossCompactIcon,
  PlayCircleIcon,
  CheckCircleIcon,
  PlayPauseIcon,
  TrashIcon,
  NoSymbolIcon,
  CogIcon,
  QueueListIcon,
} from "tir-style-system/icons/outline";
import { CheckIcon, NegativeCross } from "tir-style-system/icons/solid";
import {
  TirPmTooltipElement,
  TirPmTooltipElementPlacementEnum,
} from "tir-pm-tooltip-element";
import {
  TirPmPopover,
  TirPmStatus,
  TirPmStatusBgEnum,
  TirPmStatusTextEnum,
} from "tir-components";
import SchedulerStatusEnum from "@/pages/scheduler/models/SchedulerStatusEnum";
import EnumJobStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobStatus";
// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'sсhedule-status',
  props: {
  typeName: {
    type: Object as PropType<EnumJobStatus>,
    default: () => EnumJobStatus.Success,
  },
  isBorder: { type: Boolean, default: false },
  isColorBorder: { type: Boolean, default: false },
  isFullSize: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

// Импорты из Vue 3 Composition API


function getStyleName(): string {
  switch (props.typeName) {
    case EnumJobStatus.Success:
      return "success";
    case EnumJobStatus.Wait:
      return "pause";
    case EnumJobStatus.Running:
      return "run";
    case EnumJobStatus.Failed:
      return "error";
    case EnumJobStatus.Removed:
      return "remove";
    case EnumJobStatus.Preparing:
      return "preparing";
    case EnumJobStatus.RunWaiting:
      return "run-waiting";
    case EnumJobStatus.Disabled:
      return "disabled";
    case EnumJobStatus.Queued:
      return "queued";
  }
}

// succes error run pause remove

// // Определение эмиттеров событий компонента
// const emits = defineEmits<{
//   clickLogout: [], // Событие при клике на кнопку "Выход"
//   "update:message": [string]; // Событие обновления сообщения
// }>();

// Отслеживание изменений пропса isCompact

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["schedule-status", [{ isBorder: __props.isBorder, isColorBorder: __props.isColorBorder }]])
  }, [
    (!__props.isFullSize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (props.typeName == _unref(EnumJobStatus).Success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(CheckCircleIcon), { style: {"color":"#29a329"} })
                ]))
              : (props.typeName == _unref(EnumJobStatus).Running)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(PlayCircleIcon), { style: {"color":"#002eb8"} })
                    ])
                  ]))
                : (props.typeName == _unref(EnumJobStatus).RunWaiting)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(PlayPauseIcon), { style: {"color":"#009a9a"} })
                      ])
                    ]))
                  : (props.typeName == _unref(EnumJobStatus).Failed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(NegativeCross), { style: {"color":"#cc0000"} })
                        ])
                      ]))
                    : (props.typeName == _unref(EnumJobStatus).Wait)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_unref(ClockIcon), { style: {"color":"#cc5500"} })
                          ])
                        ]))
                      : (props.typeName == _unref(EnumJobStatus).Preparing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_unref(CogIcon), { style: {"color":"#cc8400"} })
                            ])
                          ]))
                        : (props.typeName == _unref(EnumJobStatus).Queued)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_unref(QueueListIcon), { style: {"color":"#365d6f"} })
                              ])
                            ]))
                          : (props.typeName == _unref(EnumJobStatus).Disabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_unref(NoSymbolIcon), { style: {"color":"#660000"} })
                                ])
                              ]))
                            : (props.typeName == _unref(EnumJobStatus).Removed)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_unref(TrashIcon), { style: {"color":"#7a7a7a"} })
                                  ])
                                ]))
                              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.isFullSize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (props.typeName == _unref(EnumJobStatus).Success)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 0,
                label: 'Успешно',
                "is-dotted": "",
                "bg-color": '#29A3291A',
                "label-color": '#29a329'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).RunWaiting)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 1,
                label: 'Ожидание запуска',
                "is-dotted": "",
                "bg-color": '#009A9A1A',
                "label-color": '#009A9A'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).Running)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 2,
                label: 'Выполняется',
                "is-dotted": "",
                "bg-color": '#002EB81A',
                "label-color": '#002EB8'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).Failed)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 3,
                label: 'Ошибка',
                "is-dotted": "",
                "bg-color": '#CC00001A',
                "label-color": '#CC0000'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).Removed)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 4,
                label: 'Удалено',
                "is-dotted": "",
                "bg-color": '#7A7A7A1A',
                "label-color": '#7A7A7A'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).Wait)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 5,
                label: 'Ожидание',
                "is-dotted": "",
                "bg-color": '#CC55001A',
                "label-color": '#CC5500'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).Disabled)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 6,
                label: 'Отключено',
                "is-dotted": "",
                "bg-color": '#6600001A',
                "label-color": '#660000'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).Queued)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 7,
                label: 'В очереди',
                "is-dotted": "",
                "bg-color": '#365D6F1A',
                "label-color": '#365D6F'
              }))
            : _createCommentVNode("", true),
          (props.typeName == _unref(EnumJobStatus).Preparing)
            ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                key: 8,
                label: 'Подготовка',
                "is-dotted": "",
                "bg-color": '#CC84001A',
                "label-color": '#CC8400'
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})